import { createFileRoute } from "@tanstack/react-router";
import { PopoverExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute("/demo/design-system/radix/popover")({
  component: PopoverExamples,
});
